document.documentElement.classList.remove('no-js');

const initCarousels = (scope = document) => {
  scope.querySelectorAll('[data-carousel]').forEach((carousel) => {
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    const track = carousel.querySelector('[data-carousel-track]');
    const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
    const dotsContainer = carousel.querySelector('[data-carousel-dots]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!track || slides.length < 2) return;

    let current = 0;
    let timer;

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === current));
      dotsContainer?.querySelectorAll('button').forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === current);
        dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
      });
    };

    const stopAutoplay = () => window.clearInterval(timer);
    const startAutoplay = () => {
      stopAutoplay();
      if (carousel.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const interval = Number(carousel.dataset.interval) || 5000;
      timer = window.setInterval(() => showSlide(current + 1), interval);
    };

    slides.forEach((_, index) => {
      if (!dotsContainer) return;
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Ver imagen ${index + 1}`);
      dot.addEventListener('click', () => {
        showSlide(index);
        startAutoplay();
      });
      dotsContainer.appendChild(dot);
    });

    prev?.addEventListener('click', () => {
      showSlide(current - 1);
      startAutoplay();
    });
    next?.addEventListener('click', () => {
      showSlide(current + 1);
      startAutoplay();
    });
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);
    showSlide(0);
    startAutoplay();
  });
};

const initTheme = (scope = document) => {
  initCarousels(scope);
  document.querySelectorAll('[data-accordion-button]').forEach((button) => {
    if (button.dataset.initialized === 'true') return;
    button.dataset.initialized = 'true';
    button.addEventListener('click', () => {
      const item = button.closest('.faq__item');
      const isOpen = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
    });
  });

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    if (link.dataset.smoothScrollInitialized === 'true') return;
    link.dataset.smoothScrollInitialized = 'true';
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || href.length < 2) return;
      const target = document.querySelector(href);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
};

document.addEventListener('DOMContentLoaded', () => initTheme());
document.addEventListener('shopify:section:load', (event) => initTheme(event.target));
